import { memo, useState } from "react";
import {
  FloatingPortal,
  autoUpdate,
  offset,
  useFloating,
  useHover,
  useInteractions,
  useRole,
} from "@floating-ui/react";
import { Outcome } from "@unlikelyai-magic/shared/data-access/api";
import { Paragraph } from "@unlikelyai-magic/ui/typography";
import { BaseNode } from "./BaseNode";

export const ConditionNodeSimple = memo(
  ({ id, data, isConnectable }: { id: any; data: any; isConnectable: any }) => {
    const [open, setOpen] = useState(false);
    const { refs, floatingStyles, context } = useFloating({
      open,
      onOpenChange: setOpen,
      placement: "top",
      middleware: [offset(8)],
      whileElementsMounted: autoUpdate,
    });
    const hover = useHover(context, { move: false, restMs: 50 });
    const role = useRole(context, { role: "tooltip" });
    const { getReferenceProps, getFloatingProps } = useInteractions([
      hover,
      role,
    ]);

    return (
      <>
        <div ref={refs.setReference} {...getReferenceProps()}>
          <BaseNode
            id={id}
            data={data}
            isConnectable={isConnectable}
            outcome={data.value}
          >
            <Paragraph
              color={data.value === Outcome.UNDECIDED ? undefined : "white"}
              className="font-semibold"
            >
              {data.question}
            </Paragraph>
          </BaseNode>
        </div>
        {open && data.reasoning && (
          <FloatingPortal>
            <div
              ref={refs.setFloating}
              style={floatingStyles}
              {...getFloatingProps()}
              className="max-w-sm rounded-lg p-2 bg-white border border-gray-200 shadow-lg whitespace-pre-wrap break-words z-[9999]"
            >
              <h5 className="text-sm font-semibold">Reasoning</h5>
              <Paragraph small>{data.reasoning}</Paragraph>
            </div>
          </FloatingPortal>
        )}
      </>
    );
  }
);
